export const attribute = ( el, name ) => {
    const attr = el.attributes[ name ];
    return (attr && attr.value) ? attr.value : null ;
};

export const attributeInt = ( el, name ) => {
    const attr = attribute( el, name );
    return attr !== null ? parseInt(attr) : null ;
};

export const attributeString = ( el, name ) => {
    const attr = attribute( el, name );
    return attr !== null ? attr.toString() : null ;
};
